'use client'

import type { FC } from 'react';
import { memo } from 'react';

const DEFAULT_SIZE = 24;

const PlayButton: FC<{ size?: number }> = ({ size = DEFAULT_SIZE }) => (
  <svg height={size} width={size} viewBox="0 0 12 12">
    <circle fill="rgba(0,0,0,0.5)" cx="6" cy="6" r="6" />
    <path d="M 4.5 3 L9.5 6 L 4.5 9 Z" fill="#FFF" />
  </svg>
);

export default memo(PlayButton);
